import {
  Box,
  Container,
  Grid,
  Stack,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TechBackground from "../components/TechBackground";
import logoNoText from "../../../images/logo-notext.png";

const HeroSection = () => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md")); // < md

  return (
    <Box
      id="hero"
      sx={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        py: { xs: 8, md: 12 },
      }}
    >
      <TechBackground grid vivid />

      <Container maxWidth="xl" sx={{ position: "relative", zIndex: 1 }}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction={isMdDown ? "column" : "row"}
          wrap={isMdDown ? "wrap" : "nowrap"}
          rowSpacing={6}
          columnSpacing={4}
        >
          {/* Left: Logo */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                mx: "auto",
                borderRadius: 4,
                display: "grid",
                placeItems: "center",

                width: isMdDown ? "65%" : "75%",
                maxWidth: isMdDown ? 300 : 520,
              }}
            >
              <Box
                component="img"
                src={logoNoText}
                alt="EFabric Logo"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  filter: "drop-shadow(0 6px 20px rgba(0,0,0,.08))",
                }}
              />
            </Box>
          </Grid>

          {/* Right: Text */}
          <Grid item xs={12} md={6}>
            <Stack
              spacing={isMdDown ? 4 : 6}
              sx={{
                mx: "auto",
                width: isMdDown ? "100%" : "75%",
                textAlign: isMdDown ? "center" : "left",
              }}
            >
              <Typography
                variant="overline"
                sx={{
                  color: "#3F9A82",
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                }}
              >
                EFabric
              </Typography>

              <Typography
                variant="heroTitle"
                sx={{
                  fontSize: { xs: "2.1rem", md: "3.1rem" },
                  lineHeight: 1.12,
                }}
              >
                The Operating System for AI-Driven Scientific Experiments
              </Typography>

              <Typography variant="intro">
                EFabric transforms workflows, datasets, models, and compute
                resources into managed experiments, enabling scientists to
                design, deploy, reproduce, and scale AI4Science research with
                minimal operational overhead.
              </Typography>

              <Stack
                direction="row"
                spacing={2.5}
                sx={{
                  pt: 0.5,
                  justifyContent: isMdDown ? "center" : "flex-start",
                }}
              >
                <Button
                  variant="solidButton"
                  component="a"
                  href="/docs/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Started
                </Button>

                <Button variant="outlinedButton" component="a" href="/signup">
                  Create a New Account
                </Button>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
